import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUnlock = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M6.75 8.75V5a3.25 3.25 0 1 1 6.5 0v.25M10 12.75v1.5m-5.25 4h10.5a2 2 0 0 0 2-2v-5.5a2 2 0 0 0-2-2H4.75a2 2 0 0 0-2 2v5.5a2 2 0 0 0 2 2Z"
	})]
});
const ForwardRef = forwardRef(SvgUnlock);
export { ForwardRef as ReactComponent };
